import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`

let api = {
  // 查询园区公告分页
  getYqNoticePage: `${baseUrl}/yqNotice/getYqNoticePage`,

  // 添加园区公告
  addyqNotice: `${baseUrl}/yqNotice/add`,

  // 查询园区公告
  getYqNoticeByCode: `${baseUrl}/yqNotice/getByCode`,

  // 修改园区公告
  updateyqNotice: `${baseUrl}/yqNotice/update`,

  // 删除园区公告
  deleteyqNoticeByCodes: `${baseUrl}/yqNotice/deleteByCodes`,

  // 上传图片
  uploadImg: `${baseUrl}/yqNews/uploadImg`,

  // 上传图片
  commonUploadImg: `${baseUrl}/common/uploadImg`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/yqNotice.js